import React from "react";
import ServiceTop from "../../components/layouts/ServiceTop";

//images
import llaveMano from "../../images/servicios/llave_mano.png";
import secLlaveMano from "../../images/servicios/sec_llave_mano.png";
import { LlaveEnMano } from "../../utils/itemsToogle";
import BotonContactar from "../../components/layouts/boton/BotonContactar";
import { Content } from "../../components/toggleDescComp/Content";

export default function ProyectosManos() {
  return (
    <>
      <ServiceTop
        title="Proyectos llave en mano."
        image={llaveMano}
        secImage={secLlaveMano}
        text={`Desarrollamos proyectos de calderas y vapor en su totalidad o en cualquiera de sus etapas,
         proporcionando las últimas innovaciones tecnológicas, constructivas, competitivas y soluciones sustentables, sin perder de vista la seguridad industrial
        `}
      />
      <div>
        <Content items={LlaveEnMano} />
      </div>

      <BotonContactar />
    </>
  );
}
